import { toast } from 'react-toastify'
import { useMutation } from '@tanstack/react-query'
import { errorToastOptions, successToastOptions } from 'lib/utils/toast.utils'
import { useAppDispatch /*, useAppSelector*/ } from 'store/hooks'
import {
  setOpenBottomToast,
  setBottomToastMessage,
} from 'store/SharedData/sharedData.reducer'
import { IApiError } from 'services/Shared/shared.models'
import { uploadXMLFileService } from 'services/Invoices/invoices.services'
import { API_ERRORS } from 'lib/enums/errors.enums'
import {
  setAllXmlsAmount,
  setDuplicatedXMLs,
  setErrorXMLs,
  setIsDuplicatedXMLsOpen,
  setIsErrorXMLsOpen,
  setSuccesXmlsAmount,
} from 'store/Invoices/invoices.reducer'
// import { simulateDelayedRequest } from 'services/Shared/shared.services'

interface IUploadXMLCFDIsParams {
  files: File[]
  workspaceId: number
}

const useUploadXMLCFDIs = (handleClose: () => void) => {
  const dispatch = useAppDispatch()

  const mutation = useMutation<
    (
      | {
          status: string
          value: void
        }
      | {
          status: string
          reason: unknown
        }
    )[],
    // any,
    IApiError,
    IUploadXMLCFDIsParams
  >(
    async ({ files, workspaceId }) => {
      const results = []
      for (let index = 0; index < files.length; index++) {
        const file = files[index]
        try {
          dispatch(
            setBottomToastMessage(
              `Cargando ${index + 1} de ${files.length} archivos`
            )
          )
          const result = await uploadXMLFileService({
            workspaceId,
            file,
          })
          results.push({ status: 'fulfilled', value: result })
        } catch (error: any) {
          if (error && error.code && error.message) {
            results.push({
              status: 'rejected',
              reason: `${error.code};${error.message}`,
            })
          } else {
            results.push({ status: 'rejected', reason: `${error.message}` })
          }
        }
      }
      return results
    },
    {
      onMutate: ({ files }) => {
        dispatch(setOpenBottomToast(true))
        handleClose()
      },
      onSuccess: results => {
        let isAllUploadsSuccess: boolean = true
        let isSomeUploadsError: boolean = false

        const resultsWithErrors = results.filter(
          ({ status }) => status === 'rejected'
        )

        const resultsSuccessful = results.filter(
          ({ status }) => status === 'fulfilled'
        )

        dispatch(setSuccesXmlsAmount(resultsSuccessful.length))

        if (resultsWithErrors.length > 0) {
          isAllUploadsSuccess = false
          if (resultsWithErrors.length <= results.length) {
            isSomeUploadsError = true
          }
        }

        if (isAllUploadsSuccess === true) {
          toast.success('Los CFDIs se cargaron con éxito', successToastOptions)
        }

        if (isSomeUploadsError === true) {
          const errorsDetails: string[] = resultsWithErrors.map(
            (error: any) => error.reason
          )
          const duplicatedFiles: string[] = errorsDetails.filter(elements =>
            elements.includes(API_ERRORS.CFDI_UPLOAD_0008)
          )
          const errorFiles: string[] = errorsDetails.filter(
            elements => !elements.includes(API_ERRORS.CFDI_UPLOAD_0008)
          )

          dispatch(setDuplicatedXMLs(duplicatedFiles))
          dispatch(setErrorXMLs(errorFiles))

          if (duplicatedFiles.length > 0) {
            dispatch(setIsDuplicatedXMLsOpen(true))
          } else if (errorFiles.length > 0) {
            dispatch(setIsErrorXMLsOpen(true))
          }
        }
      },
      onError: () => {
        toast.error(
          'Hubo un error inesperado la carga de CFDIs',
          errorToastOptions
        )
      },
      onSettled: (files) => {
        dispatch(setAllXmlsAmount(files ? files.length : 0))
        dispatch(setBottomToastMessage("Carga de archivos finalizada"))
      },
    }
  )

  return mutation
}

export default useUploadXMLCFDIs
